import "./App.css";
import React, { useEffect } from "react";
import ReactGa from "react-ga";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import About from "./components/About/About/About";
import Projects from "./components/Projects/Projects/Projects";
import Blog from "./components/Blog/Blog/Blog";
import Contact from "./components/Contact/Contact";
import NotFound from "./components/NotFound/NotFound";
import Header from "./components/Shared/Header/Header";
import Footer from "./components/Shared/Footer/Footer";
import ParticlesBg from "particles-bg";

function App() {
  useEffect(() => {
    ReactGa.initialize("G-3BJEY5Y0P9");

    // to report page view
    ReactGa.pageview(window.location.pathname + window.location.search);
  }, []);
  return (
    <div className="app">
      <Router>
        <Header />
        <Switch>
          <Route exact path="/">
            <About />
          </Route>
          <Route path="/home">
            <About />
          </Route>
          <Route path="/about">
            <About />
          </Route>
          <Route path="/projects">
            <Projects />
          </Route>
          <Route path="/blog">
            <Blog />
          </Route>
          <Route path="/contact">
            <Contact />
          </Route>
          <Route path="*">
            <NotFound />
          </Route>
        </Switch>
        <Footer />
      </Router>
      <ParticlesBg color="#0b0c10" num={500} type="square" bg={true} />
    </div>
  );
}

export default App;
